import React from "react";
import { LegalLayout, LegalSection, Placeholder } from "./legal/LegalLayout";

export default function MentionsLegalesPage() {
  return (
    <LegalLayout
      testid="mentions-legales-page"
      eyebrow="Informations légales"
      title="Mentions légales"
    >
      <LegalSection title="Éditeur du site" testid="section-editeur">
        <p>
          Le site <strong className="text-slate-100">Autopièce Malin</strong>{" "}
          (autopiecemalin.fr) est édité par :
        </p>
        <p>
          <strong className="text-slate-100">Olivier Girault</strong>, entrepreneur
          individuel (micro-entrepreneur)
          <br />
          38 rue Édouard Pied, 79450 Saint-Aubin-le-Cloud, France
          <br />
          SIRET : <Placeholder>À COMPLÉTER</Placeholder>
          <br />
          Adresse e-mail :{" "}
          <a
            href="mailto:olivier3835@gmail.com"
            className="text-cyan-300 hover:text-cyan-200 hover:underline"
          >
            olivier3835@gmail.com
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Directeur de la publication" testid="section-directeur">
        <p>Olivier Girault</p>
      </LegalSection>

      <LegalSection title="Hébergeur" testid="section-hebergeur">
        <p>
          Le site est hébergé par : <Placeholder>Nom de l'hébergeur</Placeholder>,{" "}
          <Placeholder>adresse complète de l'hébergeur</Placeholder>,{" "}
          <Placeholder>téléphone de l'hébergeur</Placeholder>.
        </p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle" testid="section-propriete">
        <p>
          L'ensemble des contenus présents sur le site Autopièce Malin (textes,
          graphismes, logo, interface) est la propriété d'Olivier Girault, sauf
          mention contraire. Toute reproduction sans autorisation est interdite.
        </p>
      </LegalSection>

      <LegalSection title="Nature du service" testid="section-nature">
        <p>
          Autopièce Malin est un comparateur. Le site ne vend aucune pièce
          détachée. Il identifie le véhicule à partir de la plaque
          d'immatriculation et oriente l'utilisateur vers des sites marchands tiers
          au moyen de liens d'affiliation. Les transactions, prix, stocks, livraisons
          et garanties relèvent uniquement des sites marchands partenaires.
        </p>
      </LegalSection>

      <LegalSection title="Liens d'affiliation" testid="section-affiliation">
        <p>
          Le site contient des liens d'affiliation. Lorsqu'un achat est réalisé via
          ces liens, l'éditeur perçoit une commission, sans surcoût pour l'utilisateur.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
